import { styled } from '@mui/material';
import { theme, up, lightPalette } from '../../../../theme';

export const classes = {
  root: 'root',
  containerMainGrid: 'containerMainGrid',

  rightGridForAllStep: 'rightGridForAllStep',
  rightGridMainBoxForAllStep: 'rightGridMainBoxForAllStep',

  logoBox: 'logoBox',
  resetPasswordHeader: 'resetPasswordHeader',
  rightBoxInfoSubtitleForAllStep: 'rightBoxInfoSubtitleForAllStep',

  textFieldStepOne: 'textFieldStepOne',

  textfieldStepTwo: 'textfieldStepTwo',
  resendCodeBoxStepTwo: 'resendCodeBoxStepTwo',

  textFieldStepThree: 'textFieldStepThree',
  eyeIconForPassword: 'eyeIconForPassword',
  formButtons: 'formButtons',
  formControl: 'formControl',
  submitButton: 'submitButton',
  registerTypo: 'registerTypo',
  loginLink: 'loginLink',
};

export const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.containerMainGrid}`]: {
    height: '100vh',
    background: 'rgba(255, 255, 255, 1)',
  },

  [`& .${classes.loginLink}`]: {
    fontWeight: '500',
    textDecoration: 'none',
    color: lightPalette.primary.main,
  },

  [`& .${classes.rightGridForAllStep}`]: {
    padding: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  [`& .${classes.rightGridMainBoxForAllStep}`]: {
    [up('xs')]: {
      width: '60vw',
    },
    [up('sm')]: {
      width: '30vw',
    },
    [up('md')]: {
      width: '26vw',
    },
  },

  [`& .${classes.logoBox}`]: {
    marginBottom: theme.spacing(1),
    [up('xs')]: {
      width: '90px',
    },
    [up('sm')]: {
      width: '60px',
    },
    [up('md')]: {
      width: '90px',
    },
    [up('lg')]: {
      width: '120px',
    },
    [up('xl')]: {
      width: '144px',
    },
    [up('xxl')]: {
      width: '171px',
    },
  },

  [`& .${classes.resetPasswordHeader}`]: {
    marginBottom: '1vh',
  },

  [`& .${classes.rightBoxInfoSubtitleForAllStep}`]: {
    [up('xs')]: {
      marginBottom: '8px',
    },
    [up('sm')]: {
      marginBottom: '10px',
    },
    [up('md')]: {
      marginBottom: '16px',
    },
    [up('lg')]: {
      marginBottom: '24px',
    },
    [up('xl')]: {
      marginBottom: '34px',
    },
    [up('xxl')]: {
      marginBottom: '40px',
    },
  },

  [`& .${classes.textFieldStepOne}`]: {
    [up('xs')]: {
      marginBottom: '8px',
    },
    [up('sm')]: {
      marginBottom: '20px',
    },
    [up('md')]: {
      marginBottom: '22px',
    },
    [up('lg')]: {
      marginBottom: '28px',
    },
    [up('xl')]: {
      marginBottom: '34px',
    },
    [up('xxl')]: {
      marginBottom: '40px',
    },
  },

  [`& .${classes.textfieldStepTwo}`]: {
    marginBottom: '1vh',
  },

  [`& .${classes.resendCodeBoxStepTwo}`]: {
    display: 'flex',
    justifyContent: 'end',
    [up('xs')]: {
      marginBottom: '8px',
    },
    [up('sm')]: {
      marginBottom: '20px',
    },
    [up('md')]: {
      marginBottom: '22px',
    },
    [up('lg')]: {
      marginBottom: '28px',
    },
    [up('xl')]: {
      marginBottom: '34px',
    },
    [up('xxl')]: {
      marginBottom: '40px',
    },
  },

  [`& .${classes.textFieldStepThree}`]: {
    [up('xs')]: {
      marginBottom: '8px',
    },
    [up('sm')]: {
      marginBottom: '20px',
    },
    [up('md')]: {
      marginBottom: '22px',
    },
    [up('lg')]: {
      marginBottom: '28px',
    },
    [up('xl')]: {
      marginBottom: '34px',
    },
    [up('xxl')]: {
      marginBottom: '40px',
    },
  },

  [`& .${classes.eyeIconForPassword}`]: {
    filter: 'brightness(98%) contrast(60%) sepia(10%)',
    [up('xs')]: {
      height: '10px',
      width: '10px',
    },
    [up('sm')]: {
      height: '10px',
      width: '10px',
    },
    [up('md')]: {
      height: '12px',
      width: '12px',
    },
    [up('lg')]: {
      height: '14px',
      width: '14px',
    },
    [up('xl')]: {
      height: '16px',
      width: '16px',
    },
    [up('xxl')]: {
      height: '18px',
      width: '18px',
    },
  },

  [`& .${classes.formButtons}`]: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.darker,
    },
    [up('xs')]: {
      height: '30px',
      marginBottom: '8px',
    },
    [up('sm')]: {
      height: '30px',
      marginBottom: '8px',
    },
    [up('md')]: {
      height: '36px',
      marginBottom: '14px',
    },
    [up('lg')]: {
      height: '44px',
      marginBottom: '20px',
    },
    [up('xl')]: {
      height: '52px',
      marginBottom: '26px',
    },
    [up('xxl')]: {
      height: '56px',
      marginBottom: '30px',
    },
  },
  [`& .${classes.formControl}`]: {
    width: '100%',
  },
  [`& .${classes.submitButton}`]: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  [`& .${classes.registerTypo}`]: {
    fontWeight: '400',
    textAlign: 'center',
    color: theme.palette.shoeWax.semiLight,
  },
}));
